export const articles = [
  {
    id: 1,
    title: '2026暑期档票房突破200亿，《星际迷航：新纪元》领跑',
    excerpt: '今年暑期档电影市场空前火爆，截至8月初总票房已突破200亿元大关。由克里斯·派恩主演的科幻巨制《星际迷航：新纪元》以38.5亿的成绩暂列榜首，紧随其后的是国产动画《哪吒3》和动作大片《速度与激情12》。业内人士分析，今年暑期档的爆发式增长得益于影院全面复苏以及高质量影片的集中上映。',
    content: `
      <p>2026年暑期档电影市场迎来了前所未有的繁荣景象。据国家电影局最新数据显示，截至8月10日，暑期档总票房已突破200亿元，较去年同期增长35%，创下历史新高。</p>
      
      <h3>票房三甲竞争激烈</h3>
      <p>科幻巨制《星际迷航：新纪元》以38.5亿元的成绩领跑暑期档。影片由克里斯·派恩、佐伊·索尔达娜等原班人马主演，延续了该系列一贯的高水准制作，IMAX特效场面令人叹为观止。观众纷纷评价"这是今年最值得在大银幕上观看的电影"。</p>
      
      <p>国产动画《哪吒3》以32.1亿元位列第二。作为知名IP的续作，《哪吒3》在视觉效果和故事深度上都达到了新的高度，成功吸引了全年龄段观众。而《速度与激情12》则以28.7亿元排名第三，范·迪塞尔领衔的飞车家族依然拥有强大的票房号召力。</p>
      
      <h3>国产影片表现亮眼</h3>
      <p>值得注意的是，今年暑期档国产影片的整体表现十分亮眼。在票房前十名中，国产影片占据七席，涵盖动画、喜剧、悬疑等多种类型。其中，《封神第二部》《长安十二时辰：破晓》等历史题材影片也取得了不俗的成绩，显示出观众对高品质国产电影的需求日益增长。</p>
      
      <h3>观影人次创新高</h3>
      <p>除了票房数字，观影人次的增长同样令人振奋。暑期档期间，全国观影人次突破5.2亿，同比增长28%。三四线城市成为新的增长引擎，观影人次增速超过50%。影院基础设施的完善和票价的合理化是推动下沉市场爆发的重要因素。</p>
      
      <h3>行业展望</h3>
      <p>业内专家表示，暑期档的火爆为全年票房突破800亿元奠定了坚实基础。随着国庆档和贺岁档的临近，还有多部重量级影片蓄势待发，2026年有望成为中国电影市场的新里程碑。对于观众来说，这也是一个"幸福的烦恼"——好片太多，选择困难。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Cinema%20box%20office%20theme%2C%20grand%20movie%20theater%20lobby%20with%20film%20posters%2C%20golden%20warm%20lighting%2C%20luxurious%20atmosphere%2C%20cinematic%20composition%2C%20professional%20photography%20style&width=1200&height=600&seq=article-01&orientation=landscape',
    date: '2026-08-10',
    author: '影视编辑 张明',
    views: 12800,
    tags: ['暑期档', '票房', '电影市场'],
    related: [2, 3],
  },
  {
    id: 2,
    title: '《长安十二时辰》续集官宣，原班人马重磅回归',
    excerpt: '备受期待的《长安十二时辰》续集《长安破晓》今日正式官宣。导演曹盾携雷佳音、易烊千玺等原班主演阵容回归，故事将延续前作的紧张节奏与宏大格局，预计将于2027年暑期档与观众见面。',
    content: `
      <p>今日上午，《长安十二时辰》续集《长安破晓》在横店影视城举行了隆重的开机仪式。导演曹盾及主演雷佳音、易烊千玺、周一围等悉数到场，正式宣布这部备受期待的续集启动拍摄。</p>
      
      <h3>原班人马，全新故事</h3>
      <p>据制片方透露，《长安破晓》的故事发生在前作五年之后。长安城表面平静，实则暗流涌动，一场更大的阴谋正在酝酿。张小敬（雷佳音饰）再度被卷入漩涡，而此时的李必（易烊千玺饰）已身居高位，两人将面临更加艰难的抉择。</p>
      
      <h3>制作全面升级</h3>
      <p>曹盾导演在开机仪式上表示："《长安破晓》在制作规模上将有质的飞跃。我们不仅重建了更大面积的唐城布景，还引入了一系列先进的拍摄技术，力求在视觉呈现上给观众带来全新的震撼体验。"据悉，该剧的总投资超过5亿元，单集制作成本创国产剧历史新高。</p>
      
      <h3>新角色加盟</h3>
      <p>除了原班人马，续集还将引入多个新角色。实力派演员黄轩将饰演一位来自西域的神秘商人，而新晋影后周冬雨则出演一位身份成谜的女刺客。这些新角色的加入将为剧情增添更多变数和看点。</p>
      
      <h3>观众反响热烈</h3>
      <p>消息公布后，#长安破晓开机# 话题迅速登上微博热搜榜首，阅读量两小时内突破5亿。网友们纷纷表示"终于等到了""原班人马就是最好的保障""已经开始期待2027年了"。该剧前作《长安十二时辰》在豆瓣评分高达8.2分，被誉为国产古装悬疑剧的标杆之作。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20production%20scene%2C%20Tang%20Dynasty%20film%20set%20with%20cameras%20and%20crew%2C%20ancient%20Chinese%20architecture%2C%20warm%20cinematic%20lighting&width=1200&height=600&seq=article-02&orientation=landscape',
    date: '2026-08-09',
    author: '剧集观察 李婷',
    views: 9500,
    tags: ['长安十二时辰', '国产剧', '续集'],
    related: [1, 4],
  },
  {
    id: 3,
    title: 'Netflix动画电影《深海奇缘》获奥斯卡最佳动画长片提名',
    excerpt: 'Netflix原创动画电影《深海奇缘》凭借其独特的视觉风格和动人的故事，成功入围第98届奥斯卡最佳动画长片提名名单。该片由华裔导演陈哲艺执导，讲述了一个关于海洋保护与成长的奇幻故事。',
    content: `
      <p>第98届奥斯卡金像奖提名名单于今日正式公布，Netflix原创动画电影《深海奇缘》成功入围最佳动画长片提名。这是华裔导演陈哲艺首次获得奥斯卡提名，也是Netflix连续第四年有作品入围该奖项。</p>
      
      <h3>独特的视觉美学</h3>
      <p>《深海奇缘》以其前所未有的视觉风格惊艳了整个动画界。影片采用了一种被称为"流体水墨"的独创技术，将中国传统水墨画的意境与现代CG动画技术完美融合。每一帧画面都宛如一幅精美的海洋画卷，海底世界的生物被赋予了神奇的生命力。</p>
      
      <h3>深刻的故事内核</h3>
      <p>影片讲述了一位名叫小海的少年，在一次意外中获得了与海洋生物沟通的能力。他踏上了一场穿越深海的奇幻冒险，逐渐发现了海洋生态系统面临的危机，并在与各类海洋生物的互动中学会了责任与成长。影片巧妙地将环境保护主题融入娱乐性十足的冒险故事中，获得了评论界的一致好评。</p>
      
      <h3>获奖前景分析</h3>
      <p>业内人士认为，《深海奇缘》在视觉效果方面的突破性成就是其最大的竞争优势。不过，它也将面临来自迪士尼《星愿》、皮克斯《元素大都会》等强劲对手的挑战。无论最终是否获奖，该片已经在全球动画电影史上留下了浓墨重彩的一笔。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20Oscar%20nomination%20theme%2C%20deep%20ocean%20fantasy%20world%2C%20bioluminescent%20creatures%2C%20ethereal%20underwater%20lighting%2C%20artistic%20animation%20style&width=1200&height=600&seq=article-03&orientation=landscape',
    date: '2026-08-08',
    author: '动漫前沿 王芳',
    views: 7200,
    tags: ['奥斯卡', '动画电影', 'Netflix'],
    related: [1, 5],
  },
  {
    id: 4,
    title: '国产科幻剧《三体2：黑暗森林》启动拍摄，投资额破纪录',
    excerpt: '继《三体》第一季广受好评后，续集《三体2：黑暗森林》正式启动拍摄。制作方宣布该剧总投资将超过12亿元，成为国产科幻剧集投资新纪录。',
    content: `
      <p>今日，《三体2：黑暗森林》在北京举行了盛大的启动发布会。腾讯视频和CCTV联合宣布，这部万众期待的科幻巨制续集正式开机，预计将于2027年与全球观众见面。</p>
      
      <h3>投资规模空前</h3>
      <p>据制作方透露，《三体2：黑暗森林》的总投资将超过12亿元人民币，较第一季增长了近一倍。其中，特效制作费用就高达5亿元，目标是打造世界一流的科幻视觉效果。制片人白一骢表示："黑暗森林中涉及的宇宙社会学、星际战争等宏大场景，需要我们在技术上做出更多突破。"</p>
      
      <h3>全新角色阵容</h3>
      <p>除了保留第一季的核心角色，第二季将引入罗辑、章北海、希恩斯等关键人物。据可靠消息，罗辑一角将由实力派演员张译出演，而章北海则有望由段奕宏饰演。官方表示完整演员阵容将在下月正式公布。</p>
      
      <h3>国际视野</h3>
      <p>值得一提的是，《三体2》将与Netflix展开深度合作，在全球190多个国家和地区同步播出。这也是国产科幻剧首次实现真正意义上的全球同步发行，标志着中国科幻影视作品在国际市场上迈出了重要一步。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20production%20announcement%2C%20futuristic%20stage%20with%20holographic%20displays%2C%20cosmic%20dark%20forest%20theme%2C%20cinematic%20blue%20lighting&width=1200&height=600&seq=article-04&orientation=landscape',
    date: '2026-08-07',
    author: '科幻世界 陈浩',
    views: 15600,
    tags: ['三体', '科幻', '国产剧'],
    related: [2, 3],
  },
  {
    id: 5,
    title: '鬼灭之刃剧场版全球票房突破50亿，日漫电影新里程碑',
    excerpt: '《鬼灭之刃：无限城篇》在全球上映仅两周，累计票房已突破50亿元人民币，刷新了日本动画电影全球票房纪录。',
    content: `
      <p>现象级日本动画电影《鬼灭之刃：无限城篇》自7月25日全球同步上映以来，票房一路高歌猛进。截至今日，全球累计票房已达52.3亿元人民币（约合7.2亿美元），成为日本动画电影史上票房最高的作品。</p>
      
      <h3>中国市场贡献最大</h3>
      <p>中国内地市场再次展现出强大的消费力，贡献了总票房的38%，约合19.8亿元人民币。影片在上映首周末便以6.5亿元的成绩刷新了日本动画在中国的开画纪录。IMAX和中国巨幕等高规格影厅的上座率持续保持在85%以上。</p>
      
      <h3>制作精良赢得口碑</h3>
      <p>《无限城篇》由ufotable工作室历时三年打造，采用了业界最先进的2D混合3D渲染技术。影片中决战场景的视觉震撼力被影评人誉为"达到了动画电影的天花板"。豆瓣评分9.2分，烂番茄新鲜度96%，显示出专业观众和普通观众的双重认可。</p>
      
      <h3>衍生经济蓬勃发展</h3>
      <p>随着电影的持续热映，鬼灭之刃IP的衍生品销售也迎来了爆发。仅在中国的官方授权商品销售额就突破了8亿元，覆盖手办、服饰、文具、食品等多个品类。业内分析师认为，鬼灭之刃已经成为继宝可梦、龙珠之后最具商业价值的日本动漫IP。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20box%20office%20theme%2C%20demon%20slayer%20infinity%20castle%20scene%2C%20epic%20anime%20battle%20visual%2C%20vibrant%20animation%20style&width=1200&height=600&seq=article-05&orientation=landscape',
    date: '2026-08-06',
    author: '动漫前沿 王芳',
    views: 18300,
    tags: ['鬼灭之刃', '动漫电影', '票房纪录'],
    related: [1, 3],
  },
];